@import (reference) '../../../../../../../constants/spacing.module.less';

.fbs-marketing-stats {
  display: flex;
  gap: @space-16;
  justify-content: space-between;
  max-width: 1152px;
}

.stat {
  display: flex;
  flex-flow: column nowrap;
  gap: @space-4;
  min-width: 216px;
  padding: @space-0 @space-24;
  justify-content: center;
  align-items: center;
}

.stat-main-text {
  font-weight: 700;
  text-align: center;
  width: min-content;
}
